import { Button } from "@material-ui/core"
import * as React from "react"

const downloadStoreLogoStyle = {
    maxHeight: '70px'
}

function MCIntroLogo(props, executeScroll) {

    return (<div className="h-96 flex flex-row items-center ">
                <div className="flex-1 place-content-center items-center ">
                    <img src={props.logo} alt="{props.name} logo"/>
                 </div>
                <div className="flex-1 p-20">

                    <p className="font-bold mt-10">{props.title}</p>
                    <p>{props.subtitle}</p>
                    <div className="flex flex-row pt-10 pb-10">
                        <a className="flex-auto	" href={props.appStoreLink} >
                            <img style={downloadStoreLogoStyle} src={props.appStoreLogo}/></a>
                        <a className="flex-auto	" href={props.macAppStoreLink} >
                            <img style={downloadStoreLogoStyle} src={props.macAppStoreLogo}/></a>
                    </div>
                </div>
            </div>)
}

export default MCIntroLogo